'use client';

import dayjs from 'dayjs';
import DashedLine from './DashedLine';
import EventTeaser from './EventTeaser';
import { Event } from '../../app/(main)/events/[slug]/page.val';
import { useState, useEffect } from 'react';

interface EventOverviewComponentProps {
  currentEventSlug?: string;
  events: (Event & {
    slug: string;
  })[];
  withPageHeader?: boolean;
  withinEvent?: boolean;
}

const EventOverviewComponent = ({
  currentEventSlug,
  events,
  withPageHeader = false,
  withinEvent = false,
}: EventOverviewComponentProps) => {
  const [currentDate, setCurrentDate] = useState<Date>();
  useEffect(() => {
    setCurrentDate(new Date());
  }, []);
  const previousEvents = events
    .filter(
      (event) =>
        dayjs(currentDate).isAfter(event.date, 'day') ||
        dayjs(currentDate).isSame(event.date, 'day')
    )
    .sort((a, b) => dayjs(b.date).diff(dayjs(a.date)));
  const upcomingEvents = events
    .filter(
      (event) =>
        dayjs(currentDate).isBefore(event.date, 'day') &&
        (currentEventSlug ? event.slug !== currentEventSlug : true)
    )
    .sort((a, b) => dayjs(a.date).diff(dayjs(b.date)));
  return (
    <>
      <div className="flex flex-row px-[20px] laptop:px-[50px] desktop:px-[150px] justify-center mb-[300px]">
        <div className="flex flex-col max-w-[1260px] w-full gap-[130px] tablet:gap-[130px] laptop:gap-[160px] desktop:gap-[160px]">
          {upcomingEvents.length > 0 && (
            <div className="w-full flex flex-col gap-4 laptop:gap-[0px] desktop:gap-[0px] mb-[80px]">
              <div className=" my-[80px]" />
              {withPageHeader ? (
                <h1 className="relative font-respira bg-blank-black text-blank-yellow text-[34px] tablet:text-[40px] laptop:text-[60px] desktop:text-[60px] tracking-[1%] leading-[120%] desktop:leading-[72px] laptop:mb-[-32px] desktop:mb-[-32px] z-10 w-fit ">
                  Neste Event
                </h1>
              ) : (
                <div className="relative font-respira bg-blank-black text-blank-yellow text-[34px] tablet:text-[40px] laptop:text-[60px] desktop:text-[60px] tracking-[1%] leading-[120%] desktop:leading-[72px] laptop:mb-[-32px] desktop:mb-[-32px] z-10 w-fit ">
                  Neste Event
                </div>
              )}
              <div className=" min-h-[300px] h-fit tablet:h-[476px] laptop:h-[630px] desktop:h-[630px] ">
                <EventTeaser
                  title={upcomingEvents[0].title}
                  eventSlug={upcomingEvents[0].slug}
                  date={upcomingEvents[0].date}
                  eventImage={upcomingEvents[0].eventImage}
                  speakers={upcomingEvents[0].speakers.map(
                    (speaker) => speaker.name
                  )}
                />
              </div>
            </div>
          )}
          {previousEvents.length > 0 && (
            <div>
              {upcomingEvents.length > 0 ? (
                <DashedLine className=" mb-[80px]" />
              ) : (
                <div
                  className={`${withinEvent ? 'mb-[80px]' : 'mb-[160px]'}`}
                ></div>
              )}
              <div className="relative flex flex-col justify-center w-full gap-4 ">
                <h2 className="font-respira bg-blank-black text-blank-yellow text-[34px] tablet:text-[40px] laptop:text-[40px] desktop:text-[40px] tracking-[0.1rem] leading-[120%] z-10 w-fit">
                  Tidligere events
                </h2>
                <div className="flex flex-col items-center tablet:grid tablet:grid-cols-[repeat(auto-fill,minmax(392px,1fr))] laptop:grid laptop:grid-cols-[repeat(auto-fill,minmax(392px,1fr))] desktop:grid-cols-[repeat(auto-fill,minmax(392px,1fr))] gap-x-[40px] gap-y-[150px] w-full">
                  {previousEvents.map((event, idx) => (
                    <div className=" h-[302px] w-full " key={idx}>
                      <EventTeaser
                        title={event.title}
                        eventSlug={event.slug}
                        date={event.date}
                        eventImage={event.eventImage}
                        isFutureEvent={false}
                        speakers={event.speakers.map((speaker) => speaker.name)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EventOverviewComponent;
